export const firebaseConfig = {
  apiKey: "AIzaSyCbGE8u2akEXH9ZSOZQtuW8hTCoCqGr0aI",
  authDomain: "rawora-app.firebaseapp.com",
  projectId: "rawora-app",
  storageBucket: "rawora-app.appspot.com",
  messagingSenderId: "16666519460",
  appId: "1:16666519460:web:d1777e6219588ec989c331",
  measurementId: "G-MRQ0Q5GRY3"
};
